export const THEME_COLOR_CODES = {
  globalColor: 'rgb(0, 62, 82, 1)',
  globalSubColor: 'black',
  summaryRowBackgroundColor: '#C8E5F6',
  summarySubjectBackgroundColor: '#003e52',
  summarySubjectTextColor: '#ffffff',
  summarySubjectBorderColor: '#003e52',
  summaryComparableBackgroundColor: '#ffffff',
  summaryComparableTextColor: '#003e52',
  summaryComparableBorderColor: '#003e52',
  subjectPropertyNameColor: '#003e52',
  subjectSectionHeadingColor: '#003e52',
  subjectTextbulletColor: '#003e52',
  subjectMarkerBackgroundColor: '#003e52',
  subjectMarkerTextColor: '#ffffff',
  subjectMarkerBorderColor: '#003e52',
  comparablePropertyNameColor: '#003e52',
  comparableSectionHeadingColor: '#003e52',
  comparableTextbulletColor: '#003e52',
  comparableMarkerBackgroundColor: '#ffffff',
  comparableMarkerTextColor: '#003e52',
  comparableMarkerBorderColor: '#003e52'
}

export const DONUT_CHART_COLOR_CODES = {
  'studio': 'rgba(84, 86, 90, 1)',
  'onebedroom': 'rgba(60, 180, 229, 1)',
  'twobedroom': 'rgba(0, 110, 150, 1)',
  'threebedroom': 'rgba(245, 168, 0, 1)',
  'fourbedroom': 'rgba(102, 205, 180, 1)',
  'fivebedroom': 'rgba(159, 144, 197, 1)',
  'sixbedroom': 'rgba(126, 194, 66, 1)',
  'sevenbedroom': 'rgba(255, 113, 87, 1)',
  'eightbedroom': 'rgba(0, 62, 82, 1)',
  '0bedroom/1bath': 'rgba(84, 86, 90, 1)',
  '1bedroom/1bath': 'rgba(60, 180, 229, 1)',
  '1bedroom/0.75bath': 'rgba(107, 192, 234, 1)',
  '1bedroom/1.5bath': 'rgba(107, 192, 234, 1)',
  '1bedroom/1.75bath': 'rgba(107, 192, 234, 1)',
  '1bedroom/2bath': 'rgba(141, 204, 238, 1)',
  '1bedroom/2.5bath': 'rgba(171, 217, 242, 1)',
  '1bedroom/2.75bath': 'rgba(171, 217, 242, 1)',
  '1bedroom/3bath': 'rgba(200, 229, 246, 1)',
  '1bedroom/3.5bath': 'rgba(227, 241, 250, 1)',
  '1bedroom/3.75bath': 'rgba(227, 241, 250, 1)',
  '1bedroom/4bath': 'rgba(227, 241, 250, 1)',
  '1bedroom/4.5bath': 'rgba(227, 241, 250, 1)',
  '1bedroom/4.75bath': 'rgba(227, 241, 250, 1)',
  '1bedroom/5bath': 'rgba(227, 241, 250, 1)',
  '1bedroom/5.5bath': 'rgba(227, 241, 250, 1)',
  '1bedroom/5.75bath': 'rgba(227, 241, 250, 1)',
  '1bedroom/6bath': 'rgba(227, 241, 250, 1)',
  '2bedroom/1bath': 'rgba(0, 110, 150, 1)',
  '2bedroom/0.75bath': 'rgba(4, 133, 167, 1)',
  '2bedroom/1.5bath': 'rgba(4, 133, 167, 1)',
  '2bedroom/1.75bath': 'rgba(4, 133, 167, 1)',
  '2bedroom/2bath': 'rgba(84, 156, 184, 1)',
  '2bedroom/2.5bath': 'rgba(130, 180, 201, 1)',
  '2bedroom/2.75bath': 'rgba(130, 180, 201, 1)',
  '2bedroom/3bath': 'rgba(172, 204, 219, 1)',
  '2bedroom/3.5bath': 'rgba(213, 228, 236, 1)',
  '2bedroom/3.75bath': 'rgba(213, 228, 236, 1)',
  '2bedroom/4bath': 'rgba(213, 228, 236, 1)',
  '2bedroom/4.5bath': 'rgba(213, 228, 236, 1)',
  '2bedroom/4.75bath': 'rgba(213, 228, 236, 1)',
  '2bedroom/5bath': 'rgba(213, 228, 236, 1)',
  '2bedroom/5.5bath': 'rgba(213, 228, 236, 1)',
  '2bedroom/5.75bath': 'rgba(213, 228, 236, 1)',
  '2bedroom/6bath': 'rgba(213, 228, 236, 1)',
  '3bedroom/1bath': 'rgba(245, 168, 0, 1)',
  '3bedroom/0.75bath': 'rgba(251, 182, 58, 1)',
  '3bedroom/1.5bath': 'rgba(251, 182, 58, 1)',
  '3bedroom/1.75bath': 'rgba(251, 182, 58, 1)',
  '3bedroom/2bath': 'rgba(255, 196, 101, 1)',
  '3bedroom/2.5bath': 'rgba(255, 210, 139, 1)',
  '3bedroom/2.75bath': 'rgba(255, 239, 215, 1)',
  '3bedroom/3bath': 'rgba(255, 225, 178, 1)',
  '3bedroom/3.5bath': 'rgba(255, 239, 215, 1)',
  '3bedroom/3.75bath': 'rgba(255, 239, 215, 1)',
  '3bedroom/4bath': 'rgba(255, 239, 215, 1)',
  '3bedroom/4.5bath': 'rgba(255, 239, 215, 1)',
  '3bedroom/4.75bath': 'rgba(255, 239, 215, 1)',
  '3bedroom/5bath': 'rgba(255, 239, 215, 1)',
  '3bedroom/5.5bath': 'rgba(255, 239, 215, 1)',
  '3bedroom/5.75bath': 'rgba(255, 239, 215, 1)',
  '3bedroom/6bath': 'rgba(255, 239, 215, 1)',
  '4bedroom/1bath': 'rgba(102, 205, 180, 1)',
  '4bedroom/0.75bath': 'rgba(135, 213, 190, 1)',
  '4bedroom/1.5bath': 'rgba(135, 213, 190, 1)',
  '4bedroom/1.75bath': 'rgba(135, 213, 190, 1)',
  '4bedroom/2bath': 'rgba(160, 222, 203, 1)',
  '4bedroom/2.5bath': 'rgba(184, 230, 215, 1)',
  '4bedroom/2.75bath': 'rgba(184, 230, 215, 1)',
  '4bedroom/3bath': 'rgba(208, 238, 228, 1)',
  '4bedroom/3.5bath': 'rgba(231, 246, 241, 1)',
  '4bedroom/3.75bath': 'rgba(231, 246, 241, 1)',
  '4bedroom/4bath': 'rgba(231, 246, 241, 1)',
  '4bedroom/4.5bath': 'rgba(231, 246, 241, 1)',
  '4bedroom/4.75bath': 'rgba(231, 246, 241, 1)',
  '4bedroom/5bath': 'rgba(231, 246, 241, 1)',
  '4bedroom/5.5bath': 'rgba(231, 246, 241, 1)',
  '4bedroom/5.75bath': 'rgba(231, 246, 241, 1)',
  '4bedroom/6bath': 'rgba(231, 246, 241, 1)',
  '5bedroom/1bath': 'rgba(159, 144, 197, 1)',
  '5bedroom/0.75bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/1.5bath': 'rgba(188, 166, 225, 1)',
  '5bedroom/1.75bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/2bath': 'rgba(201, 183, 231, 1)',
  '5bedroom/2.5bath': 'rgba(214, 200, 236, 1)',
  '5bedroom/2.75bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/3bath': 'rgba(228, 218, 242, 1)',
  '5bedroom/3.5bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/3.75bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/4bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/4.5bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/4.75bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/5bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/5.5bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/5.75bath': 'rgba(241, 236, 248, 1)',
  '5bedroom/6bath': 'rgba(241, 236, 248, 1)',
  '6bedroom/1bath': 'rgba(126, 194, 66, 1)',
  '6bedroom/0.75bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/1.5bath': 'rgba(143, 199, 79, 1)',
  '6bedroom/1.75bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/2bath': 'rgba(167, 210, 115, 1)',
  '6bedroom/2.5bath': 'rgba(189, 221, 149, 1)',
  '6bedroom/2.75bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/3bath': 'rgba(211, 232, 184, 1)',
  '6bedroom/3.5bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/3.75bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/4bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/4.5bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/4.75bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/5bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/5.5bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/5.75bath': 'rgba(233, 243, 218, 1)',
  '6bedroom/6bath': 'rgba(233, 243, 218, 1)',
  '7bedroom/1bath': 'rgba(255, 113, 87, 1)',
  '7bedroom/0.75bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/1.5bath': 'rgba(241, 131, 109, 1)',
  '7bedroom/1.75bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/2bath': 'rgba(247, 156, 136, 1)',
  '7bedroom/2.5bath': 'rgba(251, 180, 164, 1)',
  '7bedroom/2.75bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/3bath': 'rgba(254, 205, 194, 1)',
  '7bedroom/3.5bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/3.75bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/4bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/4.5bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/4.75bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/5bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/5.5bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/5.75bath': 'rgba(255, 229, 223, 1)',
  '7bedroom/6bath': 'rgba(255, 229, 223, 1)',
  '8bedroom/1bath': 'rgba(0, 62, 82, 1)',
  '8bedroom/0.75bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/1.5bath': 'rgba(36, 91, 109, 1)',
  '8bedroom/1.75bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/2bath': 'rgba(81, 121, 136, 1)',
  '8bedroom/2.5bath': 'rgba(123, 152, 164, 1)',
  '8bedroom/2.75bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/3bath': 'rgba(166, 185, 193, 1)',
  '8bedroom/3.5bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/3.75bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/4bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/4.5bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/4.75bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/5bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/5.5bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/5.75bath': 'rgba(209, 216, 223, 1)',
  '8bedroom/6bath': 'rgba(209, 216, 223, 1)'
}

export const BAR_CHART_COLOR_CODES = {
  'subjectPropBarColor': THEME_COLOR_CODES.globalColor,
  'compPropBarColor': '#a4a5a8',
  'wtdAvgLineBarColor': '#f5a800'
}
